import { Box, Button, TextField } from '@mui/material'
import { Formik } from 'formik'
import useMediaQuery from '@mui/material/useMediaQuery'
import Header from '../../components/Header'

import React from "react"
import { useState } from "react"
import * as Constants from '../../constants'

const Profile = () => {
  const isNonMobile = useMediaQuery('(min-width:600px)')

  const [error, setError] = useState({ error: false, message: '' })
  const [success, setSuccess] = useState({ success: false, message: '' })

  const handleFormSubmit = (values) => {
    if (values.newpass !== values.confirmpass) {
      alert('As senhas não conferem')
    } else {
      fetch(Constants.HOST + '/changePassword', {
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        body: JSON.stringify({
          token: JSON.parse(localStorage.getItem('user_data')).token,
          oldpass: values.oldpass,
          newpass: values.newpass,
        }),
      })
        .then((response) => {
          if (response.status !== 400 && response.status !== 200) {
            setError({
              error: true,
              message: 'Erro de comunicação com o servidor',
            })
            setSuccess({ success: false, message: '' })
          } else {
            response.json().then((data) => {
              if (data.success) {
                setError({ error: false, message: '' })
                setSuccess({
                  success: true,
                  message: 'Senha alterada com sucesso',
                })
              } else {
                setSuccess({ success: false, message: '' })
                setError({ error: true, message: data.message })
              }
            })
          }
        })
        .catch(() => {
          setError({
            error: true,
            message: 'Erro de comunicação com o servidor',
          })
          setSuccess({ success: false, message: '' })
        })
    }
  }

  return (
    <Box m="20px">
      <Header title="Perfil" subtitle="" />

      <h4 style={{ textAlign: 'left' }}>Alterar Senha</h4>
      {error.error && (
        <div style={{ color: 'red', margin: '10px 0' }}>{error.message}</div>
      )}
      {success.success && (
        <div style={{ color: 'green', margin: '10px 0' }}>
          {success.message}
        </div>
      )}

      <Formik onSubmit={handleFormSubmit} initialValues={initialValues}>
        {({ values, touched, handleBlur, handleChange, handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                '& > div': { gridColumn: isNonMobile ? undefined : 'span 4' },
              }}
            >
              <TextField
                fullWidth
                variant="filled"
                type="password"
                label="Senha atual"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.oldpass}
                name="oldpass"
                sx={{ gridColumn: 'span 4' }}
                autoComplete="off"
              />
              <TextField
                fullWidth
                variant="filled"
                type="password"
                label="Nova senha"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.newpass}
                name="newpass"
                sx={{ gridColumn: 'span 2' }}
                autoComplete="off"
              />
              <TextField
                fullWidth
                variant="filled"
                type="password"
                label="Confirme a nova senha"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.confirmpass}
                name="confirmpass"
                error={
                  touched.confirmpass && values.confirmpass !== values.newpass
                }
                sx={{ gridColumn: 'span 2' }}
                autoComplete="off"
              />
            </Box>
            <Box display="flex" justifyContent="end" mt="20px">
              <Button type="submit" color="secondary" variant="contained">
                Enviar
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  )
}

const initialValues = {
  oldpass: '',
  newpass: '',
  confirmpass: '',
}

export default Profile
